module.exports = __webpack_public_path__ + "assets/logo.0470af719de06928d88f33563eb4d366.png";